/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { ROUTES } from "Router";
import countPagesNumber from "utils/countPagesNumber";

import { fetchBase, FetchError, fetchV2 } from "lib";

export const getNotifications = async (offset = 0) => {
  try {
    const response = await fetchV2(`notifications?offset=${offset}`, null, {
      shouldHandleOutdated: true,
      page: ROUTES.NOTIFICATIONS,
      eventTarget: "url",
      shouldSearchForPage: false,
    });

    const res = await response.json();

    const { data, count: total, number: offsetLength, ...rest } = res;
    const numOfPages = countPagesNumber(total);

    return {
      data,
      total,
      pages: numOfPages,
      offsetLength,
      ...rest,
    };
  } catch (error) {
    console.error("Failed to fetch notifications:", error);
    throw new FetchError(error, "Failed to fetch notifications");
  }
};

export const setNotificationAsRead = async ({ notificationId, eventId }) => {
  try {
    const response = await fetchBase(
      `notifications/action/${notificationId}?event_id=${eventId}`,
      { method: "PATCH" },
      2,
    );

    const res = await response.json();
    const { data } = res;
    return { data };
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw new FetchError(error, "Failed to mark notification as read");
  }
};
